//GeneratorFlag:[NoChange]
import Region from './region';
import City from './city';
import RegionFilter from './region-filter';

export default {Region, City, RegionFilter}
export{Region, City, RegionFilter}